module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "images"
  }, [_c('div', {
    staticClass: "images__left",
    on: {
      "click": function($event) {
        _vm.goLeft()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "images__main",
    on: {
      "click": function($event) {
        _vm.showLightbox = true
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.mainImage,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "images__right",
    on: {
      "click": function($event) {
        _vm.goRight()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-right",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "lightbox"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showLightbox),
      expression: "showLightbox"
    }],
    staticClass: "lightbox"
  }, [_c('div', {
    staticClass: "lightbox-body"
  }, [_c('div', {
    staticClass: "lightbox-body__close",
    on: {
      "click": function($event) {
        _vm.showLightbox = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "lightbox-body__left",
    on: {
      "click": function($event) {
        _vm.goLeft()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "lightbox-body__image"
  }, [_c('img', {
    attrs: {
      "src": _vm.mainImage,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "lightbox-body__right",
    on: {
      "click": function($event) {
        _vm.goRight()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-50c8c792"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/WorkImages.vue
// module id = 22
// module chunks = 0